import styled from 'styled-components';
import Variables from '../../../../assets/styleVariables';


export const Modalcontainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: ${Variables.colors.complementary};
  z-index: 99999;
  .body {
    height: calc(100vh - 87px);
    overflow-y: auto;
  }
`;
export const HeaderContainer = styled.header`
  height: 63px;
  width: calc(100% - 32px);
  margin: 0 16px 24px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .close {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    &:hover {
      background-color: ${Variables.colors.complementary_250};
    }
    display: flex;
    justify-content: center;
    align-items: center;
    &:before {
      color: ${Variables.colors.complementary_900};
      margin: 0;
      font-size: 16px;
    }
  }
`;
export const Title = styled.h1`
  margin: 0 auto 24px auto;
  width: 100%;
  text-align: center;
  color: ${Variables.colors.complementary_900};
  font-size: ${Variables.font_sizes.giant};
`;
export const Message = styled.p`
  font-size: ${Variables.font_sizes.x_medium};
  color: ${Variables.colors.complementary_800};
  text-align: center;
  margin: 0 auto 24px auto;
  width: 100%;
  max-width: 360px;
  line-height: 1.57;
`;
export const Img = styled.img`
  height: auto;
  width: 100%;
  margin: 0 auto 24px auto;
  max-width: 285px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Wallet = styled.div`
  height: 32px;
  width: 304px;
  border-radius: 38px;
  background-color: ${Variables.colors.complementary_250};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  margin: 0 auto 24px auto;
  .label {
    font-size: ${Variables.font_sizes.x_small};
    font-weight: ${Variables.font_weight.medium};
    color: ${Variables.colors.complementary_800};
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      margin-left: 8px;
      &:before {
        font-size: ${Variables.font_sizes.x2_medium};
        color: ${Variables.colors.brown};
      }
    }
  }
  .amount {
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.complementary_800};
    span {
      margin-right: 7px;
    }
  }
`;
export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 320px;
  text-align: center;
  width: 100%;
  margin: 0 auto;
`;
export const MoreInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 75px;
  a {
    display: block;
    color: ${Variables.colors.primary_vivid};
    &:hover, &:focus, &:visited {
      color: ${Variables.colors.primary_vivid};
    }
  }
`;